<template>
  <svg
    v-if="iconLib === 'fluent'"
    :width="size"
    :height="size"
    fill="none"
    :viewBox="svgViewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="(path, index) in pathSource"
      :key="`path${index}`"
      :d="path.source"
      v-bind="path.props || pathProps"
    />

    <rect
      v-for="(rect, index) in rectSource"
      :key="`rect${index}`"
      v-bind="rect"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g v-for="(pathData, index) in pathSource" :key="index">
      <path
        :key="`path${index}`"
        :d="pathData.source || pathData"
        stroke="currentColor"
        stroke-width="1.66667"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconLib: {
      type: String,
      default: 'fluent',
    },
  },

  computed: {
    svgData() {
      return this.icons[`${this.icon}-${this.type}`];
    },
    svgViewBox() {
      const data = this.svgData;
      return data?.viewBox ? data.viewBox : this.viewBox;
    },
    pathSource() {
      // To support icons with multiple paths
      const data = this.svgData;
      const path = data?.path || data;
      if (path.constructor === Array) {
        return path.map(path => {
          return typeof path === 'object' && path ? path : { source: path };
        });
      }
      return [typeof path === 'object' && path ? path : { source: path }];
    },
    pathProps() {
      return {
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd',
        fill: 'currentColor',
      };
    },
    rectSource() {
      const data = this.svgData;
      const rect = data?.rect;

      if (!rect) return [];
      return Array.isArray(rect) ? rect : [rect];
    },
  },
};
</script>
